import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/node/app/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const PageDescription = makeShortcode("PageDescription");
const AnchorLinks = makeShortcode("AnchorLinks");
const AnchorLink = makeShortcode("AnchorLink");
const ImageGallery = makeShortcode("ImageGallery");
const ImageGalleryImage = makeShortcode("ImageGalleryImage");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <PageDescription mdxType="PageDescription">
      <p>{`Since 2017, I’ve had the privilege of working with a fantastic designer,
Christopher Capio.`}</p>
    </PageDescription>
    <p>{`I’ve learned so much about how to balance communicating my vision with trusting the artist to use his expertise.`}</p>
    <p>{`Chris lives in the Philippines, so we communicate mostly by Trello. If you were to follow our (often epic) cards, one theme would stand out: `}<strong parentName="p">{`iteration`}</strong>{`.`}</p>
    <AnchorLinks mdxType="AnchorLinks">
  <AnchorLink mdxType="AnchorLink">Cover Testing: Unleash Your Awesome Memory</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Illustration Iteration</AnchorLink>
    </AnchorLinks>
    <h2>{`Cover Testing: Unleash Your Awesome Memory`}</h2>
    <p>{`For my upcoming book, `}<a parentName="p" {...{
        "href": "/nonfiction/memory#unleash-your-awesome-memory"
      }}><em parentName="a">{`Unleash Your Awesome Memory`}</em></a>{`, our initial mockups followed the “brain” and “tough guy” motifs of the top-selling books in the “Memory Improvement” genre:`}</p>
    <ImageGallery mdxType="ImageGallery">
      <ImageGalleryImage alt="Cover Version" title="Unleash Your Awesome Memory: Cover Version" col={3} mdxType="ImageGalleryImage">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "160.06944444444443%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAgABQDASIAAhEBAxEB/8QAGQAAAgMBAAAAAAAAAAAAAAAAAAQBAwUC/8QAFwEAAwEAAAAAAAAAAAAAAAAAAAIDBP/aAAwDAQACEAMQAAABXpllWzzk0TtZenBfDN8D/8QAGxABAAIDAQEAAAAAAAAAAAAAAQACAxESBCL/2gAIAQEAAQUCalRHUo3vbIPExvNr3+dR85HCMMOp/8QAHBEAAQMFAAAAAAAAAAAAAAAAAAECEBESE0FR/9oACAEDAQE/AVpqLDE3p//EABoRAQACAwEAAAAAAAAAAAAAAAEAAgMEERD/2gAIAQIBAT8Bbtbc8c+Nesdwn//EABoQAAIDAQEAAAAAAAAAAAAAAAABESExEMH/2gAIAQEABj8CiG2Y+U7RTjuc9FtGwf/EABsQAAMBAQADAAAAAAAAAAAAAAABESExEFFh/9oACAEBAAE/IV1Ha6maUkulL3EGGxbfvjRlFOEKfEz0X2wbpApXNNkP/9oADAMBAAIAAwAAABCrC7L/xAAaEQEAAwADAAAAAAAAAAAAAAABABEhEEGh/9oACAEDAQE/EE7pnBTBGHZ5n//EABoRAAMAAwEAAAAAAAAAAAAAAAABESGBofD/2gAIAQIBAT8QQq77RROtSjCP/8QAHhABAAMAAQUBAAAAAAAAAAAAAQARIUEQMVFhcfD/2gAIAQEAAT8QdXYMFnNQi5gJhG7MEsAHcsuphgCu3QNDOlY/EiftiupeLXHqGpR6LjHUXFLfrcWxgFAU/dgBtWAyf//Z')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Cover Version",
            "title": "Cover Version",
            "src": "/static/b5cd56d0632d34b1d2c5e79f3cd0f597/2e753/unleash-memory-rocket.jpg",
            "srcSet": ["/static/b5cd56d0632d34b1d2c5e79f3cd0f597/69549/unleash-memory-rocket.jpg 288w", "/static/b5cd56d0632d34b1d2c5e79f3cd0f597/473e3/unleash-memory-rocket.jpg 576w", "/static/b5cd56d0632d34b1d2c5e79f3cd0f597/2e753/unleash-memory-rocket.jpg 1152w", "/static/b5cd56d0632d34b1d2c5e79f3cd0f597/490e5/unleash-memory-rocket.jpg 1600w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
    `}</span>
      </ImageGalleryImage>
      <ImageGalleryImage alt="Cover Version" title="Unleash Your Awesome Memory: Cover Version" col={3} mdxType="ImageGalleryImage">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "830px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "140.9722222222222%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAcCAYAAABh2p9gAAAACXBIWXMAABYlAAAWJQFJUiTwAAAF0klEQVRIx12We1BV1xXGv3tJh2gznc5UO9EkatvUOtXUtk5Ho0gDIqLhJWoxwUIkHfAVDCYXSAQJIijXQPCJgMHrC8QEoiIGI1JjHTVGTZxqoKRlYp3UaZs0WnlF2OfXORxQ6h/fnDl7rf3t9fjWni3z9dNw91dYTACeAB4GBL2CLkG3wJKzZuOu4Lbgn4LPXfCJH1wWVA+F0uHIrIiBimSsrXth3Vo4lAv1y+HjaPhyCrz/JBRNgHVjYcMoSPw5TPslJC6AiSEwfi4smA+TguAHwcgMmQQRcVjeHZBcCKk7IW0PFNRC/i6YGAe1F2FOFixeD54KmJYKH38BaaXw0mZI2wTTY2DqOGQiRkHkUixfDby2FWqaoOYkpG+F+FwYFQM7akAToaQWSmshcR3kVUBMOiS84eDHc2DMU8iMnATBL2L5GiB9O+yqh5brkFUOy96EsbFw4TMI90BWGWx5F34aC/sa4OkkOHUFLl2EyWHgfgaZ7wdA4hIsO7rMUvDugwtXsXIrIC4ba/RcrLJarEeCsI6fgw8vYU1NgpQisH3eeBuK33NSDhuNzFPjINKDVVaDlevrI7QqGzEp2zCVf6R3YT69RXX0zl1Hb0ENPavKMFuPQFUjVnYF1oYSKNkNgXMh2K7h40EQGol1sQ2WFWAFLIWYFAibDympkBAPeQlQ+jL8IRaSEiDDg1WyF+JyIektyCyCWdNh2BRkAgMg6XGsPaOxTg2F6iF01ftxfq/4s0/UFolje8WZ98Tpo6Ki0J+PPvghfD0W8+9ArGvhcO15aJsJ9fOQuToMOoXFfdgCzssWeTmiMF9kprrISXeRtUrEzhGFuY6P6RZWn+j94M4j8J8hyPQM6ZsIq92FuSN6vnGcD1aIA+Wi9E3hWSLWpApvlogIFAd3uQAXd2+7MXdcWB2CDhfWre8g0+6P1Sn4VmD6Rw1x5gPxyVmR4xEZK5zvxmxRkCWqdvaPobk/jn0cXUKmw79v4ZubovmS+Nd1ceGUONsojlSJbV6xv0x4s8X2jWLzelFZLr5oFicOiz0l4so5Z/ZNh1BPu3/fKeebxOsp4h2fWJEgCteKV5LE0WpRslFsyhN5rzmpv5IsthWI5fFi/Wpxs+1+lOq1CS1x7qTYnC/e3S3mhTqb8jLE25vFxdNiw2qR9bJYvVKsTBRRQSJjuchfLf7xtwcJe0VDjZOKjVeXOOR7tovSIrGvVGSudJqzeL7YUSheTRZlRaIwR/y9ZRChXUO7S3b+pxtEy2VxuEqUFztE9gF2g3zbhHeNU7PiPFFXLQ5Xij8dF+1fOQ25R9jb7nTLrpNdG89SkZsumuqc7tqNeekFp4Y2kp4TO4vFi78TN1qdvX0cA122o7PTrj8ofh8t0paJNavEqWNiUaR47lmRbtfrdaeO0cGi9YpYmya+ve1ENgCZzn5CI84cd5GX4aasyE1BppsPj7nwZrnxLHGzs9jN4nlutuS7WOtx8+lZN0eq3NDruqfB+zrsFt23RGO9OHHUQZVPVO8WTcfEiTrReFQc8Imm9x277dtwSLR95gzDvQh77jg6/PQjMTs0kJAZM4iKCGfxC3GEhExn1syZhM6YQWR4OFERYQQGBBASHETYrBAWxcUzL/pJbvzVydAR9gDheREe8wuejfkN0QueYeGiOQRMn8jsqKlMCxlPaORkZkdNY8pvxxEU9mtmhU/m+fhIZoWO4HrrIMK+lLtET5e4WeNH2343zdXiWp1ovSBa9ovWLf60lPrR/I74fL8ffyl/iJaD4uoh8WWzMF0PyIaO/iH3/ASSfwbe0VA/HG48DJuegIXjIedHEDsBFkyAwlHgGwEHHoWvHoKeBy+HDmEZYW0ciVn/GMb7GGbLo5iT38Oc+y6mchjmrREYzxhM2hiMb7jz7x2JuTwUy34UdAyO0A7XDnvgGrNFessF/3U511mns6Hv1XC3337b5cD2GdjbNZhwQEudg54g3YP+B2wP2rv+3+d/0aS/kjPukacAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Cover Version",
            "title": "Cover Version",
            "src": "/static/fbe03016f4863f9925791480f5465530/456de/unleash-memory-burst.png",
            "srcSet": ["/static/fbe03016f4863f9925791480f5465530/7fc1e/unleash-memory-burst.png 288w", "/static/fbe03016f4863f9925791480f5465530/a5df1/unleash-memory-burst.png 576w", "/static/fbe03016f4863f9925791480f5465530/456de/unleash-memory-burst.png 830w"],
            "sizes": "(max-width: 830px) 100vw, 830px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
    `}</span>
      </ImageGalleryImage>
    </ImageGallery>
    <p>{`But over time, I realized that women want to improve their memories too… and they buy far more books than men do. What if we tried appealing to those readers instead? Chris came up with some new designs.`}</p>
    <ImageGallery mdxType="ImageGallery">
      <ImageGalleryImage alt="Cover Version" title="Unleash Your Awesome Memory: Cover Version" col={3} mdxType="ImageGalleryImage">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "553px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "148.61111111111111%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,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')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Cover Version",
            "title": "Cover Version",
            "src": "/static/d56bfd0ea802a5e235f400daed3af59e/98a50/unleash-memory-meditate.png",
            "srcSet": ["/static/d56bfd0ea802a5e235f400daed3af59e/7fc1e/unleash-memory-meditate.png 288w", "/static/d56bfd0ea802a5e235f400daed3af59e/98a50/unleash-memory-meditate.png 553w"],
            "sizes": "(max-width: 553px) 100vw, 553px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
    `}</span>
      </ImageGalleryImage>
      <ImageGalleryImage alt="Cover Version" title="Unleash Your Awesome Memory: Cover Version" col={3} mdxType="ImageGalleryImage">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "548px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "149.30555555555557%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,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')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Cover Version",
            "title": "Cover Version",
            "src": "/static/2d705c99e671f7734051f17f87859cdc/8bd1a/unleash-memory-wistful.png",
            "srcSet": ["/static/2d705c99e671f7734051f17f87859cdc/7fc1e/unleash-memory-wistful.png 288w", "/static/2d705c99e671f7734051f17f87859cdc/8bd1a/unleash-memory-wistful.png 548w"],
            "sizes": "(max-width: 548px) 100vw, 548px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
    `}</span>
      </ImageGalleryImage>
      <ImageGalleryImage alt="Cover Version" title="Unleash Your Awesome Memory: Cover Version" col={3} mdxType="ImageGalleryImage">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "522px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "152.77777777777777%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,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')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Cover Version",
            "title": "Cover Version",
            "src": "/static/02bb71a759585483417b9f5f7ecd00b5/4fe5f/unleash-memory-sans.png",
            "srcSet": ["/static/02bb71a759585483417b9f5f7ecd00b5/7fc1e/unleash-memory-sans.png 288w", "/static/02bb71a759585483417b9f5f7ecd00b5/4fe5f/unleash-memory-sans.png 522w"],
            "sizes": "(max-width: 522px) 100vw, 522px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
    `}</span>
      </ImageGalleryImage>
    </ImageGallery>
    <p>{`I liked the “meditator” version best, so Chris went to work on further tweaks. Now we have a semi-final version, with some color schemes to test. Notice how he’s subtly brought back the iconic “brain” symbol.`}</p>
    <ImageGallery mdxType="ImageGallery">
      <ImageGalleryImage alt="Cover Version" title="Unleash Your Awesome Memory: Cover Version" col={3} mdxType="ImageGalleryImage">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "153.81944444444443%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAfABQDASIAAhEBAxEB/8QAGAABAQEBAQAAAAAAAAAAAAAAAAMCBAH/xAAWAQEBAQAAAAAAAAAAAAAAAAADAgH/2gAMAwEAAhADEAAAAemTwr7WB3aWzFcVn//EABsQAQEBAQADAQAAAAAAAAAAAAECAAMREhMx/9oACAEBAAEFArXFXWPzpHl+Ok9TpGJXEAC9Occ6mnf/xAAXEQEBAQEAAAAAAAAAAAAAAAABABES/9oACAEDAQE/Ad1uiAsv/8QAGBEBAAMBAAAAAAAAAAAAAAAAAQAQESH/2gAIAQIBAT8BwCYztf/EAB8QAAMAAQMFAAAAAAAAAAAAAAABERACITEScYGhsf/aAAgBAQAGPwJzWkTq9G5VF3OURFROMRfS7+Xj/8QAHRAAAgICAwEAAAAAAAAAAAAAAAERQSFRMXGBwf/aAAgBAQABPyFRtAUNIIu+BONrPRDZib4QKXUW0bGwQgbk58E5N0OTP//aAAwDAQACAAMAAAAQ9NGA/8QAGhEBAQACAwAAAAAAAAAAAAAAAQARMSFBsf/aAAgBAwEBPxDUPbBwsEU22XRf/8QAGhEAAwADAQAAAAAAAAAAAAAAAAERIUFRsf/aAAgBAgEBPxBUH4NzqQ6l0Z6f/8QAHhABAAIDAAMBAQAAAAAAAAAAAQARITFBUYHBYXH/2gAIAQEAAT8QPECllt1r7L29FcNP7G7Q1pHmZ6JHyIvyUhWd2rmoHeNqKL7B2VX4X3uALA41yHELXZXJXVJL4mmByzG8ruAz7ibtT//Z')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Cover Version",
            "title": "Cover Version",
            "src": "/static/a3f36d0ff62e076181ccfaed9fa5c6fa/2e753/unleash-memory-orange.jpg",
            "srcSet": ["/static/a3f36d0ff62e076181ccfaed9fa5c6fa/69549/unleash-memory-orange.jpg 288w", "/static/a3f36d0ff62e076181ccfaed9fa5c6fa/473e3/unleash-memory-orange.jpg 576w", "/static/a3f36d0ff62e076181ccfaed9fa5c6fa/2e753/unleash-memory-orange.jpg 1152w", "/static/a3f36d0ff62e076181ccfaed9fa5c6fa/0d3c0/unleash-memory-orange.jpg 1560w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
    `}</span>
      </ImageGalleryImage>
      <ImageGalleryImage alt="Cover Version" title="Unleash Your Awesome Memory: Cover Version" col={3} mdxType="ImageGalleryImage">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "153.81944444444443%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAfABQDASIAAhEBAxEB/8QAGQAAAwEBAQAAAAAAAAAAAAAAAAECAwQF/8QAFgEBAQEAAAAAAAAAAAAAAAAAAQAC/9oADAMBAAIQAxAAAAH1oEnSIzqGsR3JK//EABwQAAICAgMAAAAAAAAAAAAAAAECABEQIRMiMf/aAAgBAQABBQJtQMxg8dd8cHUZcWqoQxap/8QAFxEBAAMAAAAAAAAAAAAAAAAAABAREv/aAAgBAwEBPwFUaf/EABYRAAMAAAAAAAAAAAAAAAAAAAAQEf/aAAgBAgEBPwFw/8QAHRAAAgIBBQAAAAAAAAAAAAAAAAERITECECCBof/aAAgBAQAGPwKtSRnwsmjJHCiZfb2//8QAHRAAAwACAgMAAAAAAAAAAAAAAAERMUEQYSGBsf/aAAgBAQABPyG6cBYGMSr4EqbbLwhbosfB+hUpBpZOrw1y27hdGwEND//aAAwDAQACAAMAAAAQ8+jz/8QAGBEBAQEBAQAAAAAAAAAAAAAAAREAMWH/2gAIAQMBAT8QbceNS0Mge7//xAAXEQADAQAAAAAAAAAAAAAAAAAAARFR/9oACAECAQE/EFIUj0Tn/8QAHhABAQACAgIDAAAAAAAAAAAAAREAITFRcZFhgcH/2gAIAQEAAT8QSlEGN2cfuV1UbYjzjIhnY7zZqjbmquKi2tzEqyczW85zFSQ+J1kPOMGzSiX04MLicp6MqC+s/9k=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Cover Version",
            "title": "Cover Version",
            "src": "/static/ab9218f2073f6a23fb42b0af3fb10d27/2e753/unleash-memory-light.jpg",
            "srcSet": ["/static/ab9218f2073f6a23fb42b0af3fb10d27/69549/unleash-memory-light.jpg 288w", "/static/ab9218f2073f6a23fb42b0af3fb10d27/473e3/unleash-memory-light.jpg 576w", "/static/ab9218f2073f6a23fb42b0af3fb10d27/2e753/unleash-memory-light.jpg 1152w", "/static/ab9218f2073f6a23fb42b0af3fb10d27/0d3c0/unleash-memory-light.jpg 1560w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
    `}</span>
      </ImageGalleryImage>
      <ImageGalleryImage alt="Cover Version" title="Unleash Your Awesome Memory: Cover Version" col={3} mdxType="ImageGalleryImage">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "153.81944444444443%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAfABQDASIAAhEBAxEB/8QAGQAAAgMBAAAAAAAAAAAAAAAAAAMBAgQF/8QAGAEAAgMAAAAAAAAAAAAAAAAAAgMBBAX/2gAMAwEAAhADEAAAAdV6XTcQKJPE/nsbnoJGB//EABwQAAIDAQADAAAAAAAAAAAAAAECAAMREhAiMf/aAAgBAQABBQJZgEP2t/TuPaOqrCFtZ8MGaxU+P//EABsRAAIBBQAAAAAAAAAAAAAAAAABEgIQESFB/9oACAEDAQE/ActvRNEquW//xAAYEQADAQEAAAAAAAAAAAAAAAAAAREQEv/aAAgBAgEBPwGojOFbn//EAB4QAAEDBAMAAAAAAAAAAAAAAAEAEBESISIxMmGB/9oACAEBAAY/AtLTS11SBKFPrZG3S5GW/8QAHRABAAICAgMAAAAAAAAAAAAAAQARIWExUUGBkf/aAAgBAQABPyEDQt3E1rfcpauILZdR1fsubZ3Aw14mcAKyJyhOYdhCrE6VKn//2gAMAwEAAgADAAAAEDwOM//EABgRAQADAQAAAAAAAAAAAAAAAAEAESHR/9oACAEDAQE/EHoJTi7Agtkuf//EABgRAAMBAQAAAAAAAAAAAAAAAAABESFB/9oACAECAQE/ENJdLcJvGsSZ/8QAHxABAQADAAICAwAAAAAAAAAAAREAIUExYVFxgZHw/9oACAEBAAE/EDk1fDRLk9A8S7+MhAlavxhoTUNgE/uYIpL2cZoJHy8YpDXejz9lwDLDD4Z75gbFvu3ClodCP08wCAEKMebefWbbXef/2Q==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Cover Version",
            "title": "Cover Version",
            "src": "/static/91484a314762d1ce6b27e52e00b432b5/2e753/unleash-memory-red.jpg",
            "srcSet": ["/static/91484a314762d1ce6b27e52e00b432b5/69549/unleash-memory-red.jpg 288w", "/static/91484a314762d1ce6b27e52e00b432b5/473e3/unleash-memory-red.jpg 576w", "/static/91484a314762d1ce6b27e52e00b432b5/2e753/unleash-memory-red.jpg 1152w", "/static/91484a314762d1ce6b27e52e00b432b5/0d3c0/unleash-memory-red.jpg 1560w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
    `}</span>
      </ImageGalleryImage>
    </ImageGallery>
    <p>{`Does this mean we’ll go with the cover I like best? Not a chance.`}</p>
    <p>{`When it comes time to run cover tests, I’ll compare several of these covers, including the original “rocket” and “burst” versions, over days of competing ads. People do judge a book by its cover, in a split second. And I’m not the target for my books: readers are.`}</p>
    <h2>{`Illustration Iteration`}</h2>
    <p>{`My first kids’ book that Chris illustrated was `}<em parentName="p">{`How to Talk to a Rock`}</em>{`. When I first saw these spreads, I thought they were amazing.`}</p>
    <ImageGallery mdxType="ImageGallery">
      <ImageGalleryImage alt="Illustration Spread" title="Illustration Spread: How to Talk to a Rock, 1st edition" col={12} mdxType="ImageGalleryImage">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "49.65277777777777%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAIAAAA7N+mxAAAACXBIWXMAAA7EAAAOxAGVKw4bAAACbUlEQVQozwFiAp39ADtcsztftDtesztbszpbsj5ftD5ftD1gtURluEpruVduskNdrUdfq0VcqUVdiDZFiUNYp0VdqkJXrF58ggA7XbM8XrQ9X7Q9X7Q6W7JAX7RBYrZCZLdIa71KbbZ1i15bZkRhZ0JgXkqLfVaiiWxlX01kaEWCqzmg2B4AOmC1SWq6ZYHFYoDEYn3CYXzCWXW+WXa+P2K3QWO0fXFoinhpqp+ZsLmnsbanqq6bs72uoal/pdYch7I2ADxjt0NkuFNxvVR0v1d1v1h1v0VltzxdszpftURnuMDDxvLs77LcvE62ZEqmX0KQVU6yY2W5esjjlp7OLwA8Y7dAZLdMabhObrxKa7pLarlPbLo+XrM5YrdFbbvT0tvR2tFTp2Q5nEw8nU9Kolk3mUs6m0+Mw5jf4MwAOFuzTm27a4TGaYTGb4jHb4fHcIjGZX/DP2a4RWq66ufxbLJ4LplEJ5c9KJk/MZ1JI5I2MJdENJ5JuNTAADphtk1vvG6KyWaCxWmDxF56wFNwvFFtuzlgtE9rwaPQtUStV0SsWTWTSVKQVGiYXz+fTjihT0esXFSyZgA6XLNDY7ZQc79Ocr5TdL9HablJablAYbU5X7VCZrZMpGc0oEguoUQrkkNOeEtqdlM2lUc+pkA4o0Y5pVEAO12yPGC0P2K2QGW4Qmy9Qmq8Qma5Qme5QmS4QmO0VqhwLp9BMJ5FMKVGLahGK6NDK6FFS6pENqBCOKJPADtcsjtgtTtgtTtftTxkuD1nujpftT9itkJkt0Rkt9Tk4eHz4t7v4t7v4t/y4+Dz4+Dx4tru4t3w4t3v4IstKDHt5yD7AAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Illustration Spread",
            "title": "Illustration Spread",
            "src": "/static/ab6ac360b5fec0d807ad9f96248b2750/3cbba/how-talk-rock-spread-v1.png",
            "srcSet": ["/static/ab6ac360b5fec0d807ad9f96248b2750/7fc1e/how-talk-rock-spread-v1.png 288w", "/static/ab6ac360b5fec0d807ad9f96248b2750/a5df1/how-talk-rock-spread-v1.png 576w", "/static/ab6ac360b5fec0d807ad9f96248b2750/3cbba/how-talk-rock-spread-v1.png 1152w", "/static/ab6ac360b5fec0d807ad9f96248b2750/0b124/how-talk-rock-spread-v1.png 1728w", "/static/ab6ac360b5fec0d807ad9f96248b2750/6ac11/how-talk-rock-spread-v1.png 2099w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
    `}</span>
      </ImageGalleryImage>
    </ImageGallery>
    <p>{`He used a similar style for our next project, `}<em parentName="p">{`Julie and the Wishing Rock`}</em>{`.`}</p>
    <ImageGallery mdxType="ImageGallery">
      <ImageGalleryImage alt="Illustration Spread" title="Illustration Spread: Julie and the Wishing Rock, Original" col={12} mdxType="ImageGalleryImage">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "50%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAIAAAA7N+mxAAAACXBIWXMAAA7EAAAOxAGVKw4bAAACKklEQVQoz2N4b6yLid6Z6H0y0Hzi7FCu4bPT1+Rno/HHGrP7wdr7QxxOr6jdt3HVtqWFyyeGMrw31ntvgoqM9d6Z6H8y0HzsZN+r53fK1uF+rP1OZ6vd5hr9QVYduTlrJyQf2R+xY0s8w3tD7fcGWiAEZxhovTPU/qin/tTJYZax/1wZh1lyrtOlnBerubZaW9ekZe8uCDi/xvDgSkeGD3YWH1ztPzjZfnC0/uBk88HF/oOz7XsX+09Wxs+dHBYb+y9VcNii6bFGwWWttvuBtMAr9f6rY2J3ZqXvjEtl+GBv+dHf66Ovx0cv14/ebiCGn8eHAO9PLnavXByP2ITsU7Q7qO6+T9P3qF3E0aywnZMqdy3t37F52abcWIb31qYfPZ0/ujqA7Hdz+OBi99HN8YO700crk9cujleD8m9GFj9q77w7uePW7OYDOcG7K1I2TG5YP7VxXVwUw3sLow8udh9szT84WH2wt/rgYP3Byfa9ueEHbdXXHi431zRun+dXU6w3b4nyzg0C9xq0t+SYNKSbXIo0f+tvz/DeSAcUVHASzHhnovtBV+uFv92BY9qh0WyTG3N2bPI+dT7y1D71FVNV23LMds9TPjRfmQEUsaDo0QXFGSSeTfTemep90NF8GWC354BeVZXU+T01Z07aHToctnKb1uTJKhWJ5gvXy63bI8WAK5GANdvu3KO/fa9ocZvF4lUKm7bzr9wkvXi14vwlSsvWya/fKgsAdioaMIzYxzUAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Illustration Spread",
            "title": "Illustration Spread",
            "src": "/static/bdc268dd4a1d546c699a3f178fa3be74/3cbba/julie-wishing-rock-spread-v1.png",
            "srcSet": ["/static/bdc268dd4a1d546c699a3f178fa3be74/7fc1e/julie-wishing-rock-spread-v1.png 288w", "/static/bdc268dd4a1d546c699a3f178fa3be74/a5df1/julie-wishing-rock-spread-v1.png 576w", "/static/bdc268dd4a1d546c699a3f178fa3be74/3cbba/julie-wishing-rock-spread-v1.png 1152w", "/static/bdc268dd4a1d546c699a3f178fa3be74/71228/julie-wishing-rock-spread-v1.png 1628w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
    `}</span>
      </ImageGalleryImage>
    </ImageGallery>
    <p>{`But as we moved on to further books, his style improved.`}</p>
    <p>{`From `}<em parentName="p">{`The Trapped Mathbook:`}</em></p>
    <ImageGallery mdxType="ImageGallery">
      <ImageGalleryImage alt="Illustration Spread" title="Illustration Spread: The Trapped Mathbook" col={12} mdxType="ImageGalleryImage">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "50%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAIAAAA7N+mxAAAACXBIWXMAAA7EAAAOxAGVKw4bAAACaklEQVQozwXBS1ASAQAA0L117uTYlJnxVRMUWWjZXRZYl2VZ9sOyu8AKAoGAgKAoCFJqHBpTOiim42RlMnVpps7pZN27dHXKmQ4dvNWpcKaZ3gNodxIhyxSdspgzfYY8S0xz4QUcznKeOMnN+Znk+FjRnvcPutI4nOWDOXaiQDqnvEzJLeQANznDyE2MXXXxa5h3eWC8BKIZHxKUCN6FJu5aJ3VY/taWV70U0hsLdrsiYCHGIVHOyB0oD5gcNTG2CZN1iKhZ8YoOLMFw3EVmMFdyzJGzQzE1nYJeo8YH1JAtB2NxqysJYikrmhgypwHQWfFH1oOJlhxv0XKz31BolKrtnd2jg339OA6b/IbFqOcVYm+hxrSCuGchLmcFEQT2maEMgLOr8dy2HN8Upx4Lk+sQVVtphjYbieNGC7U4QJM4NC+jz1DwJXF6JP/oKN86oe+H/vND4byjAGSgOVd/MV3czZb38gvPJ4LV3be2g63AR6JsthaGyZxvx2N+hyc3nP/eh7ufI5cnyp8PkctPse5pFLBg84z00CeusXKT5FdQsrIxwz0Jx86yS0Fhtt8wbbTdgyRluUB0H+G/DkIXneSXk42LPen3thcYNUR89IIsNXiuKgq1UTBZvWrNqqn20zYXSPf2UDw6Y+eYK8v2WMz0NZU+Lhd/vil262N/KyMACqelQJ2m5jlmkeeqeq0UHgkqZom9v68lysPXHe1iZjZGR22DzD3iLErvBBHPBB6HqIiNAjQqUa+VdRpJoxI1qoB6QFANJ3RaxYJkNMaE+iZ7e0AYUQlEP5VCQiknixqpnhv+a31ib5/4H+PM2Yaxyt/6AAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Illustration Spread",
            "title": "Illustration Spread",
            "src": "/static/6c8280b7f9cb877ba2cb7e844a5b95f2/3cbba/trapped-mathbook-spread.png",
            "srcSet": ["/static/6c8280b7f9cb877ba2cb7e844a5b95f2/7fc1e/trapped-mathbook-spread.png 288w", "/static/6c8280b7f9cb877ba2cb7e844a5b95f2/a5df1/trapped-mathbook-spread.png 576w", "/static/6c8280b7f9cb877ba2cb7e844a5b95f2/3cbba/trapped-mathbook-spread.png 1152w", "/static/6c8280b7f9cb877ba2cb7e844a5b95f2/0b124/trapped-mathbook-spread.png 1728w", "/static/6c8280b7f9cb877ba2cb7e844a5b95f2/85c88/trapped-mathbook-spread.png 1783w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
    `}</span>
      </ImageGalleryImage>
    </ImageGallery>
    <p>{`From `}<em parentName="p">{`The Shopping Mall Dragon:`}</em></p>
    <ImageGallery mdxType="ImageGallery">
      <ImageGalleryImage alt="Illustration Spread" title="Illustration Spread: The Shopping Mall Dragon" col={12} mdxType="ImageGalleryImage">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "50.34722222222222%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAIAAAA7N+mxAAAACXBIWXMAAA7EAAAOxAGVKw4bAAACaklEQVQozzWR7U8ScQDH7w+orbZ601Zv6oW9qPWiOV9QW0Wt1ctelLnVPIQ78DiOU1vDsqFJmw0sVEYPgiiiwgHieD45TlaGsVI3IGuWAl2C9mA+DTH9tevhzffdZ9/Pd19IT31roJfvhyeHEi+xYKnBmyW9nNqXJofzzeF5IrLZwBTJ8A8Nm1NEgTIKiP9JMABKYR7ctx6JG8DMVfP4dK33uyr0hYgCJJ5VvojD7p8alkM8y0RgTR4syv3reGhTHtjAwyUiCiCcBkN9fvuoPfZW1xRdl0cB6czdbe6Djbrrb97Xs0Dm3xBbP1abUiLLjMgyA5uSqIPDQ0W+Wf04zEmOemtqMKrQGM+oEoUWqaz79D7d2YPPRapJzTTqWap+OiXqeSfqScPmtNS9RDDbShYQEQA5qmrSj+4km6SG2s52ckSHuAYeds2FuuYD+gcqraZjjmQBMpRDBjOog0PsOalrUeosYL5VXtt+u3V5zJbqbqPOtLGnqMjJnki9YykxsBYzYbapK0FQFylJBjMS25xkMCvu/4Q4OH4zXeK1tZfgrKGFvaUNHesIX7T6Bf20cHi81+YKemS+IskAeYDfDJt5Z9iUhE1JsXWWYHZ4uE1tWdRXTTxrbSdjI+VGj8DYf9nNmNUJ6kZ9aJVggcy9eNPwWmROi62zqDOPUguYb4V/i9mBOi1PMirog77Mb0M5VdnX5iNTOsGE8cLnRqijr7c2BpTMNkotSJ151FnAvCvK2L+T+eZr93qFJw5XVhyQVOzChHvw83tRwe7K8v3njh+qarHVvQKK0V8KektBb+F0SUFv/RHe+Qv/BhgEe5DpKqXfAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Illustration Spread",
            "title": "Illustration Spread",
            "src": "/static/9ccb8e3e72d6e5c524b054f915b32fa0/3cbba/shopping-mall-dragon-spread.png",
            "srcSet": ["/static/9ccb8e3e72d6e5c524b054f915b32fa0/7fc1e/shopping-mall-dragon-spread.png 288w", "/static/9ccb8e3e72d6e5c524b054f915b32fa0/a5df1/shopping-mall-dragon-spread.png 576w", "/static/9ccb8e3e72d6e5c524b054f915b32fa0/3cbba/shopping-mall-dragon-spread.png 1152w", "/static/9ccb8e3e72d6e5c524b054f915b32fa0/b06cb/shopping-mall-dragon-spread.png 1625w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
    `}</span>
      </ImageGalleryImage>
    </ImageGallery>
    <p>{`So I’ve had him go back and level up his earlier illustrations. It’s fascinating what a transformative change it is to improve the faces.`}</p>
    <ImageGallery mdxType="ImageGallery">
      <ImageGalleryImage alt="Illustration Spread" title="Illustration Spread: How to Talk to a Rock, 2nd edition" col={12} mdxType="ImageGalleryImage">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "50.34722222222222%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAIAAAA7N+mxAAAACXBIWXMAAA7EAAAOxAGVKw4bAAACbUlEQVQozwFiAp39AKXcHKnjFazmEpnYKyJ3uBpzwB94uiR8tRd0xxhzxCJ7th94uh54ux50tR5LkBlerSF8th11uSF2thNqyAB9nlOh1iKo5BKhzg9hcUpiakVrc0FxeDleaVFhak1tdTpocUBrckFoaz68mnaSgGJqcjlpcEBncDlXYVIAZ35sjbk2oMc9gH9qfnBkfnJmf3JpfnJrgnRlgXJmfXBpgXFpeXNmdXNhkKichZF8c3JhfXVpe2xmfXBfAIanV63fMpqqiI2SmY2XlIyVlI+WlZSbmqCtrKazsqexsZuzrDWvbjO1cSSGUymYXDK0bT6tc6GxrZ+trQCWo5+hq6yXoZ2Ij4yHjIuIjoyMkI6Ynpykrq2cp6Wkp6lTqXwUoVQKmkwbn1YWmEsOmU0UoVRlqYafo6UAn6qplp+ckpqZlJ2ckpuakJmXl5+eoaupoK2qmZ6fbJiCIZ1YHJVSC5BHH5pXH5pRDpNHHplWJZ1bdpOGAKKsqo2TkYCDgoGEg4CDgoGGhYWIh4iNjJegnpqspyigXhaeUwSXRgObSA6iVA2gTQefRQuYRhaeUzKgZACirauRlZSEhYSEhoWDhoWEiYeDhYWWoZ6qrbFNpnYWo1YhqF0QlFEreVGCiG5wj2obploOpVcgqWEZo1YAn6qol5+dmqGfmaCflpybmJ+ej5mXn6GkfqyXEZ9QEp9RAJZCAJJDCoVCPHRLNIFMAJdHLbFDEKdIFKVbAKGsqp+qqaKsq6WvrqCrqZ2pp56op5qqpiihXxGfUAOXRQCVQgCWQgCYQwCbQwGeRQCaRxukQwqjSgCdShPAGcuT83fgAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Illustration Spread",
            "title": "Illustration Spread",
            "src": "/static/acb0194411799d967d99227c8c2737a8/3cbba/how-talk-rock-spread-v2.png",
            "srcSet": ["/static/acb0194411799d967d99227c8c2737a8/7fc1e/how-talk-rock-spread-v2.png 288w", "/static/acb0194411799d967d99227c8c2737a8/a5df1/how-talk-rock-spread-v2.png 576w", "/static/acb0194411799d967d99227c8c2737a8/3cbba/how-talk-rock-spread-v2.png 1152w", "/static/acb0194411799d967d99227c8c2737a8/8a49c/how-talk-rock-spread-v2.png 1629w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
    `}</span>
      </ImageGalleryImage>
    </ImageGallery>
    <ImageGallery mdxType="ImageGallery">
      <ImageGalleryImage alt="Illustration Spread" title="Illustration Spread: Julie and the Wishing Rock, Revised" col={12} mdxType="ImageGalleryImage">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "51.041666666666664%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAIAAAA7N+mxAAAACXBIWXMAAA7EAAAOxAGVKw4bAAACbUlEQVQozwFiAp39AH4jQYElQ4QmRIUnRIcnRYgnRokoRokoRokoRogoRokpRpIvSIMnSLJRQ9FzTMJmVdR9ZcN5bqdaZ71rZQCKJ0ONJkKPJkKRJkOTKESVKESVKESVKUWWK0eUK0ikNEvGQVPCT03tiEXqiUzTj2TWlmPfsHq3n4/TspEAlylCoTlQrVBkrElfrUtgrUlfslJnsU9kqT1Uoy9IpDNKoS9Ks0ZL4XhJ1HRLyXJls29vv42Mz868ubW3AKYvRLRNX7hQYrlRY7tSZbxRZL1SZbtMX7I2TLA1Sq82TLc8TrY7TasxSLRGSbx2VcB8Y717cK+gj72UhQCzM0W9R1jDVGTDUWHFVWTETl3AQlPAQVG+PU7EQE3HPkzIQU/GRVXCSV/HYmXQeFXCeUGWdD6gbUHhZ0UAwDlHwzxKyk1Yy0tXzEtWzU5ZzlFbzlBZy0dQz0pY2mp1wXB4y4uG3KmJ06uA1qtwzJ9ai21Dl3NQ34NiAMxASc5BSc9BSdBDSdJES9NEStJCRthTW994geaghZ+CXF9aUaaZXMDAL8HCKre1KLSyLY5wQpuFPca+PgDVR0nXSEvYSkvZTEvaS0ncT07meX7jo4rNsl7JwTloZxq/rJLd0G7T2GXRt2HDlUGhkjd8Z0CIdz6urjMA3EhF3kpF30xG30tC41dR65KJ1bRqvbUuubUlvrctsagnk5JPsq9BwKg1topFv4w+ppoupKEwqKQxsK0wAONkW+RlW+VmWuZqXe+imdTAcL+7O8O8RsS8ScK7R8zERpGZUKSmR8C2Prq2Prq4P8S+RcfARsbARsW+RvZtJkY2Ii6nAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Illustration Spread",
            "title": "Illustration Spread",
            "src": "/static/463346f303adb440e66d056fed3c36b2/3cbba/julie-wishing-rock-spread-v2.png",
            "srcSet": ["/static/463346f303adb440e66d056fed3c36b2/7fc1e/julie-wishing-rock-spread-v2.png 288w", "/static/463346f303adb440e66d056fed3c36b2/a5df1/julie-wishing-rock-spread-v2.png 576w", "/static/463346f303adb440e66d056fed3c36b2/3cbba/julie-wishing-rock-spread-v2.png 1152w", "/static/463346f303adb440e66d056fed3c36b2/2bf0f/julie-wishing-rock-spread-v2.png 1621w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
    `}</span>
      </ImageGalleryImage>
    </ImageGallery>
    <p>{`Chris does excellent work, and he always has infinite patience, whether I’m asking for a fresh redesign or honing in on the small details. I’m very, very lucky to have him on my team.`}</p>
    <p>{`So are our clients. 😉`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      